/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { Column } from "app/partials/entity/Table";
import PageWrapper from "app/partials/entity/PageWrapper";
import { emptyDriver, Driver } from 'app/modules/tp/drivers/_models';
import driverApi from 'app/modules/tp/drivers/_requests';
import DriverFormBuilder from 'app/modules/tp/drivers/builders/DriverFormBuilder';
import CheckboxSwitch from 'app/partials/form/CheckboxSwitch';

const columns: Array<Column<Driver>> = [
    {
        key: "provider",
        label: "Fornitore",
        render: (driver: Driver) => (<>{`${driver?.provider.name?? ""} ${driver?.provider?.surname ?? ""}` }</>),
    },
    {
        key: "name",
        label: "Nome",
        filterable: true,
        sortable: true,
    },
    {
        key: "surname",
        label: "Cognome",
        filterable: true,
        sortable: true,
    },
    {
        key: "phone",
        label: "Telefono",
        filterable: true,
        sortable: true,
    },
    {
        key: "email",
        label: "Email",
        filterable: true,
        sortable: true,
    },
    {
        key: "identity_card",
        label: "N° Carta d'Identità",
        filterable: true,
        sortable: true,
    },
    {
        key: "available",
        label: "Documento caricato",
        filterable: true,
        sortable: true,
        render: (driver: Driver) => (driver?.document_file ? <>Sì</> : <>No</>)
    }
];

const entityIcon = "fa-solid fa-user";

const DriversPage: React.FC = () => {
    const [form] = React.useState<any>(DriverFormBuilder());

    return (
        <PageWrapper
            columns={columns}
            emptyEntity={emptyDriver}
            entityIcon={entityIcon}
            entityApi={driverApi}
            labels={{
                icon: entityIcon,
                singleEntityName: "Autista",
                pluralEntityName: "Autisti",
            }}
            form={form}
        />
    );
}


export { DriversPage }
